module.exports = __webpack_public_path__ + "static/media/time_ic.4833abf9.svg";